// mediaTagging/tagSendable.js — may this box go to the server yet?
//
// A box is sendable when it carries at least one keyword, a level (1 or 2), a complete geometry and — depending on
// the medium — its position: a page for PDFs, a start time for videos. Anything else stays in memory until it is
// complete or the popup closes (plan bugfix_2026-10-06_permission-tagging, phase speichern). The reason feeds the
// warning in the tag list. Pure, testable without jQuery.

export const UnsendableReason = Object.freeze({
    NO_KEYWORD:  'no-keyword',
    NO_LEVEL:    'no-level',
    NO_GEOMETRY: 'no-geometry',
    NO_PAGE:     'no-page',
    NO_TIME:     'no-time',
});

const GEOMETRY_KEYS = ['left', 'top', 'width', 'height'];

// Why this box cannot be sent yet — or null when it can. mediaType: 'image' | 'video' | 'pdf' (the popup type).
export function unsendableReason(model, mediaType) {
    if (!model) { return UnsendableReason.NO_GEOMETRY; }
    const keywords = String(model.text ?? '').split(',').map((k) => k.trim()).filter(Boolean);
    if (!keywords.length) { return UnsendableReason.NO_KEYWORD; }
    const level = Number(model.level);
    if (level !== 1 && level !== 2) { return UnsendableReason.NO_LEVEL; }
    if (!GEOMETRY_KEYS.every((k) => model[k] !== null && model[k] !== '' && Number.isFinite(Number(model[k])))) {
        return UnsendableReason.NO_GEOMETRY;
    }
    const page = model.metadata?.page;
    if (mediaType === 'pdf' && !(Number.isInteger(page) && page >= 1)) { return UnsendableReason.NO_PAGE; }
    const startTime = model.metadata?.startTime;
    if (mediaType === 'video' && !(typeof startTime === 'number' && Number.isFinite(startTime) && startTime >= 0)) {
        return UnsendableReason.NO_TIME;
    }
    return null;
}

export function isSendableTag(model, mediaType) {
    return unsendableReason(model, mediaType) === null;
}
